<app-material>
    <div class="header" header>
        <div class="title">
            <h2>{{ 'admin.lifts.title' | translate }}</h2>
            <div class="mutators">
                <app-button class="add-lift"
                            (clicked)="onAddLiftButtonClick()">
                    {{ 'admin.lifts.addButton' | translate }}
                </app-button>
                <app-icon class="filter-action" library="material" variant="filter_list" role="button" tabindex="0"
                          [class.active]="filtersExpanded" [attr.aria-expanded]="filtersExpanded"
                          aria-controls="lifts-tool-filter-form" [attr.aria-label]="'admin.lifts.filterLifts' | translate"
                          [placeholder]="'admin.lifts.filterLifts' | translate" (click)="toggleFilters()"
                          (keydown.enter)="toggleFilters()" (keydown.space)="$event.preventDefault(); toggleFilters()"></app-icon>
            </div>
        </div>
        <div class="search">
            <app-input [placeholder]="'admin.lifts.search' | translate"
                       [formControl]="filterControl('search')">
            </app-input>
        </div>
        <app-lift-tool-filters *ngIf="filtersExpanded" id="lifts-tool-filter-form"
                               [form]="filterForm"
                               [allLinesLabel]="'admin.lifts.filters.allLines' | translate"
                               [lines]="lines$ | async">
        </app-lift-tool-filters>
    </div>

    <ng-container body>
        <div class="list-content">
            <app-loading-spinner *ngIf="isLoadingLifts$ | async" class="loading-animation"></app-loading-spinner>
            <app-lift-list [class.loading]="isLoadingLifts$ | async"
                           [items]="lifts$ | async"
                           [config]="config"
                           (reachEnd)="onScrollReachEnd($event)"
                           (selectLift)="onSelectLiftClick($event)"
                           (openLiftInNewTab)="onOpenLiftInNewTab($event)">
            </app-lift-list>
        </div>
    </ng-container>
</app-material>

<app-lift-create-modal
    [plants]="plants$ | async"
    (create)="onCreateLift($event)">
</app-lift-create-modal>
